module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp3-5db1203da798cdcc47ac8c3f330c19a1.jpg";